import React from 'react';
import { string, func, array, bool } from 'prop-types';
import { message } from 'antd';
import copyToClipboard from '../../../utils/copyToClipboard';

import {
  DropdownContent,
  DropdownItem,
  DropdownList,
  DropdownAction,
} from '../../ui-helpers/dropdown';
import { SvgIcon } from '../../svg-icon';

import { ROUTES } from '../../../routes/constants';
import { createLink } from './helpers';
import { Popconfirm } from '../../popovers';

export const TaskDropdownComp = ({
  _id,
  title,
  subject,
  contacts,
  requestId,
  hideActions,
  handleTaskUpdate,
  handleTaskDelete,
}) => {
  const text = createLink(title, subject, contacts, ROUTES.TASK, _id);
  const onCopy = () => message.success('Link successfully copied');

  return (
    <DropdownContent width={200}>
      <DropdownList>
        {!hideActions && <DropdownItem>
          <DropdownAction onClick={() => copyToClipboard(text, onCopy)}>
            <span>
              <SvgIcon type="link" width={10} height={10} />
              Share via link
            </span>
          </DropdownAction>
        </DropdownItem>}

        <DropdownItem>
          <DropdownAction onClick={() => handleTaskUpdate(_id, requestId)}>
            <SvgIcon type="pencil" />
          Edit
          </DropdownAction>
        </DropdownItem>

        <DropdownItem>
          <Popconfirm
            title="Are you sure you want to delete this task?"
            onConfirm={() => handleTaskDelete(_id)}
          >
            <DropdownAction data-popconfirm-stay-open>
              <SvgIcon type="trash" width={14} />
            Delete
            </DropdownAction>
          </Popconfirm>
        </DropdownItem>
      </DropdownList>
    </DropdownContent>
  );
};


TaskDropdownComp.propTypes = {
  _id: string.isRequired,
  title: string,
  contacts: array.isRequired,
  requestId: string.isRequired,
  handleTaskUpdate: func.isRequired,
  handleTaskDelete: func.isRequired,
  subject: string,
  hideActions: bool,
};

TaskDropdownComp.defaultProps = {
  subject: '',
  title: '',
  hideActions: false,
};



// WEBPACK FOOTER //
// ./src/components/tasks-list/task-dropdown/index.js